import React from 'react';
import { Chip } from '@mui/material';
import { ORDER_STATUS } from '../data/orderTypes';

const statusColorMap = {
  [ORDER_STATUS.NEW]: 'default',
  [ORDER_STATUS.ASSIGNED]: 'info',
  [ORDER_STATUS.IN_PROGRESS]: 'warning',
  [ORDER_STATUS.COMPLETED]: 'success',
  [ORDER_STATUS.REJECTED]: 'error'
};

const OrderStatusChip = ({ status, size = 'small' }) => (
  <Chip
    label={status}
    size={size}
    color={statusColorMap[status] || 'default'}
    variant={status === ORDER_STATUS.NEW ? 'outlined' : 'filled'}
  />
);

export default OrderStatusChip;
